<main class="main-home-secton">
  <div class="event-main">
    <div class="container">
      <div class="div-header">
        <h1>Accelators Details</h1>
      </div>
      <div class="event-details-div">
        <div class="row">
          <div class="col-lg-4 col-md-4 col-sm-12 col-12">
            <div class="event-titles-details">
              <h1>{{ accelaroeView.eventName }}</h1>
            </div>
            <div class="" style="word-wrap: break-word">
              <ion-icon name="location-outline"></ion-icon>
              {{ accelaroeView.eventLocation }}
            </div>
            <hr />
            <div class="incubator-detail-div">
              <div class="d-flex">
                <div>
                  <img
                    [src]="accelaroeView.incubatorLogo"
                    class="img-fluid img-logo"
                    alt=""
                  />
                </div>
                <div class="ml-3">
                  <h5>{{ accelaroeView.incubatorName }}</h5>
                </div>
              </div>
            </div>
            <hr />
            <div class="event-date mt-4">
              <div class="row mb-3">
                <div class="col-6 date-div">
                  <ion-icon name="calendar-clear-outline"></ion-icon> Start Date
                  <h5 class="date-h5">
                    {{ accelaroeView.eventFromDate }}
                  </h5>
                </div>
                <div class="col-6 date-div" *ngIf="accelaroeView.eventToDate">
                  <ion-icon name="calendar-clear-outline"></ion-icon> End Date
                  <h5 class="date-h5">
                    {{ accelaroeView.eventToDate }}
                  </h5>
                </div>
              </div>
              <hr />
              <div class="row">
                <div class="col-6 date-div">
                  <ion-icon name="time-outline"></ion-icon> Start Time
                  <h5 class="date-h5">
                    {{ accelaroeView.eventFromTime }}
                  </h5>
                </div>
                <div class="col-6 date-div" *ngIf="accelaroeView.eventToTime">
                  <ion-icon name="time-outline"></ion-icon> End Time
                  <h5 class="date-h5">
                    {{ accelaroeView.eventToTime }}
                  </h5>
                </div>
              </div>
              <hr />
            </div>
            <div class="event-reg">
              <h5>Registration Details</h5>
              <div class="row">
                <div class="col-6" *ngIf="accelaroeView.eventRegQRFileName">
                  <h6>QR Code</h6>
                  <div>
                    <img
                      [src]="accelaroeView.eventRegQRFileName"
                      class="img-fluid"
                      alt=""
                    />
                  </div>
                </div>
                <div class="col-6">
                  <div *ngIf="accelaroeView.eventFromDate">
                    <ion-icon name="calendar-clear-outline"></ion-icon> Last
                    Date
                    <h5 class="date-h5">
                      {{ accelaroeView.eventFromDate }}
                    </h5>
                  </div>
                  <div *ngIf="accelaroeView.eventRegLink" class="pt-3">
                    <a [href]="accelaroeView.eventRegLink" target="_blank"
                      >Registration Link</a
                    >
                  </div>
                  <div *ngIf="accelaroeView.eventWebsiteLink" class="pt-3">
                    <a [href]="accelaroeView.eventWebsiteLink" target="_blank"
                      >Website Link</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-8 col-md-8 col-sm-12 col-12">
            <div class="event-form-div">
              <img
                [src]="accelaroeView.eventImageName"
                class="img-fluid event-img"
                alt=""
              />
            </div>
            <div
              class="event-descrption"
              *ngIf="accelaroeView.eventDescription"
            >
              <h5>Description</h5>
              <div
                [innerHtml]="accelaroeView.eventDescription | safeHtml"
              ></div>
            </div>
          </div>
          <div class="col-12 text-center">
            <button
              mat-raised-button
              color="warn"
              (click)="backBtn()"
              [ngClass]="{ 'd-none': roleValue == 'Incubator' }"
            >
              <ion-icon name="arrow-back-outline"></ion-icon> Back
            </button>
            <button
              mat-raised-button
              color="warn"
              *ngIf="roleValue == 'Incubator'"
              (click)="backBtn2()"
            >
              <ion-icon name="arrow-back-outline"></ion-icon> Back
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>
<app-footer></app-footer>
